define('prototypes/GoogleMaps',['site_vars','jquery'],function (site_vars,$) {
    // wrap google maps loader sync
    $.ajax({
        async:false,
        url: site_vars.googleMapsApi,
        dataType: "script"
    });
});
